import React from "react";
import styles from './index.module.css';
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";

const Footer = () => {

    return (
        <>
            <div className={`main-container ${styles.footerContainerBottom2}`}>
                <div className={`container-content ${styles.footer}`}>
                    <div className={styles.bottomFooter}>
                        <div className={styles.bottomFooterLower}>
                            Copyright © {new Date().getFullYear()}{" "} Ardillalabs
                        </div>
                        <div className={styles.bottomFooterIcons}>
                            <a href="https://www.linkedin.com/company/ardilla-labs/" target="_blank" rel="noopener noreferrer">
                                <FaLinkedin className={styles.socialIcon} />
                            </a>
                            <a href="https://www.facebook.com/ardillalabs" target="_blank" rel="noopener noreferrer">
                                <FaFacebookSquare className={styles.socialIcon} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;